import React, { useContext, useEffect, useRef } from 'react';
import { DishesSelectionContext } from 'app/containers/contexts/dishesSelection.context';
import classNames from 'classnames';
import { analyticService } from 'global/services';
import { maxiBlockContentKeyVar } from 'app/apollo/reaction';
import css from './PromoMaxiBlock.module.scss';

interface IPromoMaxiBlockProps {
    contentKey: 'kids' | 'sauces',
    selectionKey: string,
    observer: any,
}

const promoBlocksData = {
    kids: {
        title: 'Детское',
        subtitle: 'меню',
        description: {
            firstLine: 'Хиты всех детей с 4 лет (и до 99).',
            secondLine: 'Весело готовить вместе!',
        },
        backgroundImageClass: 'kids',
    },
    sauces: {
        title: 'Соусы',
        subtitle: 'от шеф-повара',
        description: {
            firstLine: 'Наши авторские хиты: песто, луковый джем, блючиз и другие',
            secondLine: '',
        },
        backgroundImageClass: 'sauces',
    },
};

export const PromoMaxiBlock = ({ contentKey, selectionKey, observer }: IPromoMaxiBlockProps) => {
    const {
        title, subtitle, description, backgroundImageClass,
    } = promoBlocksData[contentKey];
    const { onOpenSelection } = useContext<any>(DishesSelectionContext);
    const rootRef = useRef<any>(null);

    const handleSendAnalytics = () => {
        analyticService.push({
            eventName: 'Collection_Click',
            banner_name: 'Sauces',
            source_name: 'menu',
        });
    };

    const handleOpenSelection = () => {
        handleSendAnalytics();
        onOpenSelection({ tag: `maxi_${selectionKey}`, targetRealm: 'new_upsell' });
    };
    const buttonStyles = classNames({
        [css.maxiBlockButton]: true,
        [css[contentKey]]: contentKey !== undefined,
    });

    useEffect(
        () => {
            maxiBlockContentKeyVar(contentKey);
        },
        [contentKey],
    );
    useEffect(
        () => {
            if (rootRef.current) {
                observer.observe(rootRef.current);
            }
        },
        [],
    );

    return (
        <div
            className={`${css.maxiBlockRoot} ${css.mobileOnly}`}
            ref={rootRef}
            onClick={handleOpenSelection}
            role="none"
        >
            <div className={`${css.maxiBlockContent} ${css[backgroundImageClass]} ${css.smallRadius}`}>
                <div className={css.maxiBlockTitle}>
                    {title}
                    <br />
                    {subtitle}
                </div>
                <div className={css.maxiBlockDescription}>
                    {description.firstLine}
                    <br />
                    {description.secondLine}
                </div>
                <div
                    className={css.maxiBlockButtonLink}
                >
                    <div className={buttonStyles}>Хочу попробовать</div>
                </div>
            </div>
        </div>
    );
};
